// Add your own custom JS here.

/* Houroffer catalog lead routing */
(function () {
  function routeCatalogLinks() {
    if (window.location.pathname === '/pages/catalog') return;
    document.querySelectorAll('a[href*="2026_new_catalog.pdf"], a[href*="/cdn/shop/files/2026_new_catalog.pdf"]').forEach(function (link) {
      var text = (link.textContent || '').toLowerCase();
      if (text.indexOf('catalog') !== -1 || link.href.indexOf('2026_new_catalog.pdf') !== -1) {
        link.setAttribute('href', '/pages/catalog');
        link.removeAttribute('target');
        link.removeAttribute('rel');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', routeCatalogLinks);
  } else {
    routeCatalogLinks();
  }
})();

/* Keep OEM quote CTAs on the OEM page and send visitors straight to the RFQ form. */
(function () {
  var oemPath = '/pages/oem-odm';
  var contactPath = '/pages/contact';
  var rfqHash = '#oem-rfq';
  var legacyRfqHash = '#B2BInquiryForm';
  var contactFormPath = '/pages/contact#FactoryQuoteForm';

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getPath(href) {
    if (!href) return '';
    try {
      return new URL(href, window.location.href).pathname;
    } catch (error) {
      return href.split('?')[0].split('#')[0];
    }
  }

  function getHash(href) {
    if (!href) return '';
    try {
      return new URL(href, window.location.href).hash;
    } catch (error) {
      return href.charAt(0) === '#' ? href : '';
    }
  }

  function pointsToMissingInlineRfq(href) {
    var hash = getHash(href);
    var path = getPath(href);
    return (hash === rfqHash || hash === legacyRfqHash) && (path === oemPath || path === window.location.pathname);
  }

  function isOemQuoteCta(link) {
    var text = cleanText(link.textContent || link.getAttribute('aria-label') || '');
    var href = link.getAttribute('href') || '';
    return /(quote|inquiry|oem|odm|factory)/.test(text) && (getPath(href) === contactPath || pointsToMissingInlineRfq(href));
  }

  function scrollToRfq(event) {
    var target = document.getElementById('oem-rfq');
    if (!target) return;

    event.preventDefault();
    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', rfqHash);
    } else {
      window.location.hash = rfqHash;
    }

    window.scrollTo({
      top: Math.max(target.getBoundingClientRect().top + window.pageYOffset - 96, 0),
      behavior: 'smooth'
    });
    window.setTimeout(function () {
      var field = target.querySelector('input:not([type="hidden"]), select, textarea, button');
      if (field && typeof field.focus === 'function') field.focus({ preventScroll: true });
    }, 500);
  }

  function initOemQuoteRouting() {
    if (window.location.pathname !== oemPath) return;
    var hasInlineRfq = Boolean(document.getElementById('oem-rfq'));

    document.querySelectorAll('a[href]').forEach(function (link) {
      if (isOemQuoteCta(link)) {
        link.setAttribute('href', hasInlineRfq ? rfqHash : contactFormPath);
      }
    });

    if (!hasInlineRfq) return;

    document.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (getHash(href) === rfqHash || getHash(href) === legacyRfqHash || isOemQuoteCta(link)) {
        scrollToRfq(event);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOemQuoteRouting);
  } else {
    initOemQuoteRouting();
  }
})();

/* Houroffer Factory Capability canonical routing */
(function () {
  var canonicalFactoryPage = '/pages/factory-capability-manufacturer';
  var oldFactoryPaths = ['/pages/factory-capability', '/pages/factory-capability-2026', '/pages/factory-capability-live'];

  function pointsToOldFactory(href) {
    if (!href) return false;
    for (var i = 0; i < oldFactoryPaths.length; i += 1) {
      if (href === oldFactoryPaths[i] || href.indexOf(oldFactoryPaths[i] + '?') === 0 || href.indexOf(oldFactoryPaths[i] + '#') === 0) {
        return true;
      }
    }
    return false;
  }

  function rewriteFactoryLinks() {
    document.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      if (pointsToOldFactory(href)) {
        link.setAttribute('href', canonicalFactoryPage);
      }
    });
  }

  if (oldFactoryPaths.indexOf(window.location.pathname) !== -1) {
    window.location.replace(canonicalFactoryPage);
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteFactoryLinks);
  } else {
    rewriteFactoryLinks();
  }
})();


/* Houroffer New Mold canonical routing */
(function () {
  var canonicalNewMoldPage = '/pages/custom-drinkware-mold-development';
  var oldNewMoldPaths = ["/pages/new-mold-development","/pages/new-mold-development-custom-drinkware"];

  function isOldNewMoldHref(href) {
    if (!href) return false;
    for (var i = 0; i < oldNewMoldPaths.length; i += 1) {
      var path = oldNewMoldPaths[i];
      if (href === path || href.indexOf(path + '?') === 0 || href.indexOf(path + '#') === 0) return true;
    }
    return false;
  }

  function rewriteNewMoldLinks() {
    document.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      if (isOldNewMoldHref(href)) link.setAttribute('href', canonicalNewMoldPage);
    });
  }

  if (oldNewMoldPaths.indexOf(window.location.pathname) !== -1) {
    window.location.replace(canonicalNewMoldPage);
    return;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rewriteNewMoldLinks);
  else rewriteNewMoldLinks();
})();
